export default {
  ON_BOARDING_EMAIL_STATE_MANAGER: Symbol.for('ON_BOARDING_EMAIL_STATE_MANAGER'),
  ON_BOARDING_SEARCH_EMAIL_REPOSITORY: Symbol.for('ON_BOARDING_SEARCH_EMAIL_REPOSITORY'),
  ON_BOARDING_SEARCH_EMAILS_QUERY: Symbol.for('ON_BOARDING_SEARCH_EMAILS_QUERY'),
};
